import '../css/all.css';
import Pic from "../assests/mypic.png"
import Book from "../assests/book.png";
import Laptop from "../assests/laptop.png";
import Footaball from "../assests/football.png";
import Swipe from "../assests/swipe.png";

import React from 'react';
import { CarouselProvider, Slider, Slide} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
 
export default class Projects extends React.Component {
  render() {
    return (
        <div className="container mt-5 ">
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={125}
        totalSlides={3}
      >
        <Slider>
          <Slide index={0}> 
          <div className="row align-items-center">
             <div className="col  align-items-center">
                 <img  src={Pic} alt="pic" className="pic mx-auto d-block"></img>
                 
                 <div className="col  align-items-center name">
                            <h3 >Hi, I'm Satyam</h3>
                            <h2>Full stack Developer</h2>
                            <p className="tagline mt-2">I’m not a great programmer; I’m just a good programmer with great habits</p>
                 </div>
             </div>
             </div>
             <div className="swipe " ><img alt="pic" src={Swipe} className="pic swipe-logo"></img></div>
             </Slide>
          <Slide index={1}>
              <div className="row align-items-center">
             <div className="col  align-items-center">
               
                 <div className="col  align-items-center name">
                            <h3 className="mt-5" >Skills</h3>
                            <h2 className="subject">Development</h2>
                            <div className="container mt-3 tcenter">
                                <div className="row tcenter">
                                <p className="tags">React</p> 
                                <p className="tags">Flutter</p> 
                                <p className="tags">CSS</p>
                                <p className="tags">HTML</p> 
                                <br>
                                </br> 
                                <p className="tags">PHP</p> 
                                <p className="tags">JS</p> 
                                <p className="tags">Git</p> 
                                </div>
                            
                            </div>
                            <h2 className="subject">Tools</h2>
                            <div className="container mt-3 tcenter">
                                <div className="row tcenter">
                                <p className="tags">VScode</p> 
                                <p className="tags">Figma</p> 
                                <p className="tags">Gravit</p>
                                <p className="tags">postman</p>
                                
                                <br>
                                </br> 
                                
                               
                                </div>
                            
                            </div>
                                   
                            </div>
             </div>
             </div></Slide>
          <Slide index={2}> 
          <div className="row align-items-center">
             <div className="col  align-items-center">
               
                 <div className="col  align-items-center name">
                            <h3 className="mt-5" >Passions</h3>
                              
                            <div className="container mt-3 tcenter">
                                <div className="row tcenter ">
                                <img src={Book} alt="pic" className="mx-auto d-block"></img> 
                                </div>
                                <div className="row tcenter ">
                                <p className="tags-logo headings">Learning</p> 
                                </div>
                            <br></br>
                              <div className="row tcenter ">
                                  <img src={Laptop} alt="pic" className="mx-auto d-block"></img> 
                                  </div>
                                  <div className="row tcenter ">
                                  <p className="tags-logo headings">Technology</p> 
                                  </div>
                                  <br></br>
                                  <div className="row tcenter ">
                                  <img src={Footaball} alt="pic" className="mx-auto d-block"></img> 
                                  </div>
                                  <div className="row tcenter ">
                                  <p className="tags-logo headings">Gaming</p> 
                                  </div>
                            </div>
                           
                           
                                   
                            </div>
                            
             </div>
             </div>
         </Slide>
        </Slider>
      </CarouselProvider>
      </div>
    );
  }
}